import React from 'react';
import CampanaNotificaciones from './CampanaNotificaciones';

const Header = ({ title, subtitle }) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-4 lg:px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0 pl-12 lg:pl-0">
            <h1 className="text-2xl font-bold text-gray-900 truncate">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-gray-600 truncate">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <CampanaNotificaciones />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
